function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "search");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("defs", null);

var _ref5 = /*#__PURE__*/React.createElement("g", {
  id: "search",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  fill: "#C3C3C3",
  fillRule: "nonzero",
  id: "Shape"
}, /*#__PURE__*/React.createElement("path", {
  d: "M14.77125,13.8983036 L11.1396429,10.12125 C12.0733929,9.01125 12.585,7.61464286 12.585,6.16071429 C12.585,2.76375 9.82125,0 6.42428571,0 C3.02732143,0 0.263571429,2.76375 0.263571429,6.16071429 C0.263571429,9.55767857 3.02732143,12.3214286 6.42428571,12.3214286 C7.69955357,12.3214286 8.91482143,11.9367857 9.95383929,11.2066071 L13.6130357,15.0123214 C13.7659821,15.1711607 13.9716964,15.25875 14.1921429,15.25875 C14.4008036,15.25875 14.59875,15.1791964 14.7490179,15.0345536 C15.0683036,14.7273214 15.0784821,14.2178571 14.77125,13.8983036 Z M6.42428571,1.60714286 C8.93517857,1.60714286 10.9778571,3.64982143 10.9778571,6.16071429 C10.9778571,8.67160714 8.93517857,10.7142857 6.42428571,10.7142857 C3.91339286,10.7142857 1.87071429,8.67160714 1.87071429,6.16071429 C1.87071429,3.64982143 3.91339286,1.60714286 6.42428571,1.60714286 Z"
})));

var SvgSearch = function SvgSearch(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "15px",
    height: "16px",
    viewBox: "0 0 15 16",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSearch, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/search.1c656ede.svg";
export { ForwardRef as ReactComponent };